import { Component, OnInit, Inject, ChangeDetectorRef, AfterViewChecked,
  ViewChild, AfterViewInit, ChangeDetectionStrategy  } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatTableDataSource, MatPaginator } from '@angular/material';
import { TagParameters } from '../../../../models/index';
import { NgForm, FormControl, Validators, FormGroup, FormBuilder, FormGroupDirective } from '@angular/forms';
import { SiteService } from '../../../../services/site.service';
import { AlertService } from 'src/app/shared';
@Component({
  selector: 'app-data-tag',
  templateUrl: './data-tag.component.html',
  styleUrls: ['./data-tag.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DataTagComponent implements OnInit, AfterViewChecked, AfterViewInit {
  @ViewChild('formDirective') formDirective: FormGroupDirective;
  disableSelect = new FormControl(false);
  tagTypeControl = new FormControl('', [Validators.required]);
  tagDescriptionControl = new FormControl('', [Validators.required, Validators.maxLength(50)]);
  formdata: FormGroup;
  // formdata = new FormGroup({
  //   tagTypeCtr: new FormControl('', [Validators.required]),
  //   tagDescCtr: new FormControl('', [Validators.required, Validators.maxLength(50)])
  // });
  tagParameters: TagParameters;
  fromDate: string;
  toDate: string;
  tagData: MatTableDataSource<any>;
  displayedColumns = ['dataTagID', 'tagType', 'tagDescription', 'tagValid', 'taggedBy', 'modifiedTime'];
  @ViewChild(MatPaginator) paginator: MatPaginator;
  constructor(public dialogRef: MatDialogRef<DataTagComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private siteService: SiteService,
    private cdRef: ChangeDetectorRef,
    private alertService: AlertService,
    private fb: FormBuilder
    ) {
    this.tagParameters = <TagParameters>data.tagParameters;
    this.fromDate = data.fromDate;
    this.toDate = data.toDate;
  }
  ngOnInit() {
    this.formdata = this.fb.group({
      tagTypeCtr: ['',  [Validators.required]],
      tagDescCtr: ['', [Validators.required, Validators.maxLength(50)]]
    });
    this.fetchTaggedData();
  }
  public isFieldHasError = (fieldName: string, errorCode: string): boolean => {
    return this.formdata.get(fieldName).hasError(errorCode);
  }
  isFieldInvalid(field:  string) {
    return (
    (!this.formdata.get(field).valid && this.formdata.get(field).touched) ||
    (this.formdata.get(field).untouched)
    );
  }
  ngAfterViewInit() {
    this.cdRef.detectChanges();
  }

  ngAfterViewChecked() {
    this.cdRef.detectChanges();
  }
  public submit = () => {
    this.tagParameters.taggedBy = 'admin'; // Will get from logged in
    this.siteService.saveDataTag(this.tagParameters).subscribe((data: any) => {
     this.tagParameters.message = data.message;
     this.alertService.message = data.message;
     this.alertService.showSuccess();
     this.formDirective.resetForm();
     this.formdata.reset();
    });
  }
  public onSelectedTab = (event: any) => {
    if (event.index === 1) {
      this.fetchTaggedData();
    } else {
      this.formDirective.resetForm();
      this.formdata.reset();
    }
  }
  private fetchTaggedData = () => {
    this.siteService.fetchTaggedData(this.tagParameters.siteID,
      this.fromDate,
      this.toDate, this.tagParameters)
      .subscribe(res => {
        this.tagData = new MatTableDataSource<any>(res);
        this.tagData.paginator = this.paginator;
  });
  }
  closeDialog() {
    this.dialogRef.close();
  }
}
